import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'icon-plus',
    templateUrl: './icon-plus.component.html',
    styleUrls: ['./icon-plus.component.scss'],
    standalone: false
})
export class IconPlusComponent implements OnInit {

  @Input() makingSelectionsState: boolean | undefined;
  @Input() leftPosition: string | undefined;
  @Input() topPosition: string | undefined;

  @Input() selectedItem:boolean | undefined = false;

  constructor() { }

  ngOnInit(): void {
    
  }


}
